import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { Subject, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { PosReport } from '../models/posReport';
import { UtilsService } from './utils.service';


@Injectable({
  providedIn: 'root'
})
export class PosReportingServiceService {

  transactionSubject = new Subject<any[]>();
  constructor(private http: HttpClient,
    private configService: ConfigurationService,
    private notifService: NotifMessageService,
    private utilsService:UtilsService) { }

  saveSubject = new Subject<any[]>();

  url : string ="/posEvolution";

  getPosEvolutionByPeriod(criteria): Observable<any> {
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<PosReport>(this.configService.config.urlAPI.urlPosReports + this.url, { params: criteria }).pipe(catchError(err => {
      console.log("error getPosEvolutionByPeriod", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
      return of(null);
    }));
  }
}
